module.exports = __webpack_public_path__ + "New MDI Logo Gary W.png?83f348d95851bb836fd8978a7f324385";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/marathondynamics/New MDI Logo Gary W.png
// module id = 194
// module chunks = 0